'use client';

import { Suspense } from 'react';
import dynamic from 'next/dynamic';
import styles from './Layout.module.css';
import Navbar from '../Navbar/Navbar';

const Footer = dynamic(() => import("../Footer/Footer"), {
  ssr: false
});

export default function Layout({ children }) {
  return (
    <div className={styles.layoutContainer}>
      {/* Navbar */}
      <Navbar />

      {/* Main Content - key forces remount on route change */}
      <main className={styles.mainContent}>
        {children}
      </main>

      {/* Footer */}
      <Suspense fallback={<div className={styles.footerLoader}>Loading...</div>}>
        <Footer />
      </Suspense>
    </div>
  );
}
